<div class="float-drag" cdkDrag>

	<div class="float-container">
        <div class="float-header" cdkDragHandle>
			<div class="header-text">Layer Controller</div>
			<i class="glyphicons glyphicons-remove" (click)="close()"></i>
        </div>

		<div class="layer-control-content">
			<div class="data-layer">
				<app-layer-control-item [layerItem]="dataLayer" (toggleLayer)="onToggleDataLayer($event)"></app-layer-control-item>
			</div>
			<div class="ref-layer">
				<app-layer-control-item [layerItem]="refLayer" (toggleLayer)="onToggleRefLayer($event)"></app-layer-control-item>
			</div>
			<div>
				<app-layer-control-item [layerItem]="fishboneControl" (toggleLayer)="onToggleFishbone()"></app-layer-control-item>
			</div>
			<div *ngIf="reportRefLayer" class="report-ref-layer">
				<app-layer-control-item [layerItem]="reportRefLayer" (toggleLayer)="onToggleReportRefLayer($event)"></app-layer-control-item>
			</div>
			<div *ngIf="countyLayer" class="county-layer">
				<app-layer-control-item [layerItem]="countyLayer"></app-layer-control-item>
			</div>
		
		
			<div class="bdry-layers">
				<app-layer-control-item [layerItem]="bdryLayer" (selectItem)="onSelectBdry($event)"></app-layer-control-item>
		
				<!-- <select name="layer-option" [(ngModel)]="selectedBdry" (ngModelChange)="onSelectBdry()">
					<option *ngFor="let bdry of bdryLayers" [ngValue]="bdry">{{bdry.label}}</option>
				</select> -->
			</div>
		
			<div class="base-layers">
				<app-layer-control-item [layerItem]="baseLayer" (selectItem)="onSelectBasemap($event)"></app-layer-control-item>
			</div>
		</div>


	</div>
</div>
